import { VerticalDivider } from "@@/shared/dividers/vertical-divider";
import { FlexColumn, FlexRow } from "@@/shared/flex-containers";
import { GlobalMaxWidthCss } from "@@/shared/global-max-width";
import { Icon } from "@@/shared/icons/icon";
import { TextBox } from "@@/shared/text/text-box";
import { useTheme } from "@emotion/react";
import { faTimesCircle } from "@fortawesome/pro-duotone-svg-icons";
import {
    fromTranslatableString,
    translatableStringFactory,
} from "@towni/common";
import { useSearchParams } from "react-router";

const EmailVerificationFailedPage = () => {
    const theme = useTheme();
    const [searchParams] = useSearchParams();
    const errorMessage = fromTranslatableString(
        searchParams.get("error")?.trim() ||
            translatableStringFactory({
                sv: "Verifieringen misslyckades",
                en: "Verification failed",
                de: "Verifizierung fehlgeschlagen",
            }),
    );

    return (
        <>
            <GlobalMaxWidthCss />
            <FlexColumn
                crossAxis="center"
                css={{
                    flex: 1,
                    backgroundColor: theme.colors.default.background.asString,
                }}>
                <FlexColumn
                    mainAxis="center"
                    crossAxis="center"
                    css={{ flex: 1, paddingBottom: 40 }}>
                    <FlexRow
                        fillParentWidth
                        mainAxis="center"
                        crossAxis="center"
                        css={{ paddingTop: 10 }}>
                        <Icon
                            icon={faTimesCircle}
                            size={5}
                            colors={{
                                primaryColor: theme.colors.danger.asString,
                                secondaryColor: theme.colors.danger.asString,
                                secondaryOpacity: 0.15,
                            }}
                        />
                    </FlexRow>
                    <VerticalDivider M />
                    <TextBox
                        text={{
                            sv: "Något gick fel",
                            en: "Something went wrong",
                            de: "Etwas ist schief gelaufen",
                        }}
                        weight="900"
                        size="XL"
                        align="center"
                        padding={{ all: 20 }}
                    />
                    <TextBox
                        text={errorMessage}
                        weight="400"
                        size="ML"
                        align="center"
                        css={{ maxWidth: 300 }}
                    />
                </FlexColumn>
            </FlexColumn>
        </>
    );
};

export { EmailVerificationFailedPage };
